import { AccessTokenType, AuthResponseType } from '@/types/sharedTypes';
import { jwtDecode } from 'jwt-decode';

export const decodeToken = <T>(token: string): T => {
  try {
    const decodedToken = jwtDecode(token);

    return decodedToken as T;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAccessToken = (body: AuthResponseType) => {
  const { access, refresh } = body;
  const { user_id } = decodeToken<AccessTokenType>(body?.access);
  const token = { access, refresh, user_id };

  return { token };
};
